"use client";
import React, { useEffect, useState } from "react";

import { loadStripe } from "@stripe/stripe-js";
import {
  Elements,
  CardElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import StripeCheckout from "../../../components/StripeCheckout";
import axios from "axios";
import { useRouter } from "next/navigation";
import { useShoppingCart } from "../../../contexts/CartContext";
import { useSelector } from "react-redux";

const stripePromise = loadStripe(
  process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY
);

export default function Payment(props) {
  const {
    courses,
    cartItems,
    paymentData,
    totalPriceToShow,
    setOpenPaymentDrawer,
  } = props;
  const router = useRouter()

  const activeCurrency = useSelector(
    (state) => state.currency.activeCurrency
  );

  
  // const [stripePromise, setStripePromise] = useState(null);
  const [clientSecret, setClientSecret] = useState("");
  const [paymentInfo, setPaymentInfo] = useState(null);
  const [requestedForPaymentIntentData, setRequestedForPaymentIntentData] = useState(false)
  const { cartItemsCoupons } = useShoppingCart();

  const baseUrl =
    process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
      ? process.env.NEXT_PUBLIC_API_URL_PROD
      : process.env.NEXT_PUBLIC_API_URL_DEV;

  const createPaymentIntent = async () => {
    const coursesReferred = JSON.parse(localStorage.getItem("coursesRefferedByOrg")) || [];

    const tracksReferred = JSON.parse(localStorage.getItem("tracksRefferedByOrg")) || [];

    // Map through each course and extract only the courseId (before the '_')
    const courseIdsReferred = coursesReferred.map((course) => {
      const [courseId] = course.split("_"); // Get the courseId before the '_'
      return courseId;
    });

    // Map through each course and extract only the trackId (before the '_')
    const trackIdsReferred = tracksReferred.map((course) => {
      const [trackId] = course.split("_"); // Get the trackId before the '_'
      return trackId;
    });

    const organizationsReferred =
      JSON.parse(localStorage.getItem("organizationsReferred")) || [];

    // Map through each course and extract only the courseId (before the '_')
    const organizationIdsReferred = organizationsReferred.map((org) => {
      const [orgId] = org.split("_"); // Get the orgId before the '_'
      return orgId;
    });


    const cartPaymentInfo = JSON.parse(localStorage.getItem("cartPaymentInfo")) || [];

    const getOnlyCourses = cartPaymentInfo?.filter((course) => course?.courseId);
    const courseIdsCheckout = () => {
      return cartPaymentInfo
        ? Object.keys(getOnlyCourses)
            .map(function (k) {
              return getOnlyCourses[k]["courseId"];
            })
            .join("-")
        : "";
    };

    const paymentIntentData = {
      userId: paymentData?.userId,
      independentCourseIds: courseIdsCheckout(),
      independentCourseIdsWithCoupons : cartItemsCoupons,
      tracksAndTerms: paymentData?.tracksAndTerms,
      coursesRefferedByOrg: courseIdsReferred,
      tracksRefferedByOrg: trackIdsReferred,
      organizationsReferred: organizationIdsReferred,
      selected_currency: activeCurrency || "USD"
    };
    
    

    const response = await axios.post(
      baseUrl + "/createPaymentIntent",
      paymentIntentData
    );
    const data = response.data;
    
    if(data?.paymentInfo){
      setClientSecret(data.clientSecret);
      setPaymentInfo(data?.paymentInfo);
      setRequestedForPaymentIntentData(true)
    }
  };
  useEffect(() => {
    createPaymentIntent();
  }, []);

  useEffect(() => {
    console.log(requestedForPaymentIntentData, 'requestedForPaymentIntentData')
  },[requestedForPaymentIntentData])
  return (
    <div className="PM_Form_Container">
      <div className="FieldBox">
        {clientSecret && stripePromise && (
          <Elements stripe={stripePromise} options={{ clientSecret }}>
            <StripeCheckout
              courses={courses}
              cartItems={cartItems}
              paymentData={paymentData}
              paymentInfo={paymentInfo}
              clientSecret={clientSecret}
              setPaymentInfo={setPaymentInfo}
              totalPriceToShow={totalPriceToShow}
              setOpenPaymentDrawer={setOpenPaymentDrawer}
            />
          </Elements>
        )}
      </div>
      
      {(requestedForPaymentIntentData && !clientSecret && !paymentInfo?.error) && <button 
        style={{
          width: "100%",
          height: "48px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontFamily: "Poppins",
          fontSize: "14px",
          fontWeight: "600",
          color: "#fff",
          borderRadius: "16px",
          background: "#ff6200",
          border: "#ff6200 1px solid",
          cursor: "pointer",
        }}
        onClick={(e) => router.push(`${window.location.origin}/payment-status?success=true&payment-id=${paymentInfo?.paymentData?.paymentId}&free=true`)}
      >
        <span id="button-text">Proceed</span>
      </button>}

      <div className="PM_AllRights">
        <p>
          By continuing, you agree to our{" "}
          <a href="/terms-of-service-main" target="_blank">
            Terms of Service
          </a>{" "}
          and
          <a href="/privacy-policy-main" target="_blank">
            Privacy Policy.
          </a>
        </p>
      </div>

      {/* <div className="AllRights">
        <p>© 2023 DEENFUND <FiberManualRecordIcon /> All rights reserved <FiberManualRecordIcon /> Privacy Policy <FiberManualRecordIcon /> Terms of Use</p>
        <div className='PowerBy'>
          <Image className='OrgLogo' src={DfLogo} />
          <span> Powered by <a href='#'>DEENFUND</a></span>
        </div>
      </div> */}
    </div>
  );
}
